module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_02_1280_1280_en-038f984b3ab57d795c2ca5e85ddc3140.jpg";